export default {
  api: 'https://poll.now.sh'
  // api: 'http://localhost:8082'
}


// WEBPACK FOOTER //
// ./src/config.js